import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import AdbIcon from "@mui/icons-material/Adb";
import { Link } from "react-router-dom";
import tamperproof_blue from "../../assets/logo-blue.png";
import tamperproof_blue2 from "../../assets/tamperproof_blue.webp";
import { FormControl, InputLabel, Select } from "@mui/material";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import "./style.css";
const pages = ["Products", "Pricing", "Blog"];
// const settings = ["Profile", "Account", "Dashboard"];

function Navbar(props) {
	const [anchorElNav, setAnchorElNav] = React.useState(null);
	const [anchorElUser, setAnchorElUser] = React.useState(null);
	const { i18n, t } = useTranslation();
	const handleOpenNavMenu = (event) => {
		setAnchorElNav(event.currentTarget);
	};
	const handleOpenUserMenu = (event) => {
		setAnchorElUser(event.currentTarget);
	};

	const handleCloseNavMenu = () => {
		setAnchorElNav(null);
	};

	const handleCloseUserMenu = () => {
		setAnchorElUser(null);
	};

	const handleLanguageChange = (e) => {
		console.log(e.target.value);
		i18n.changeLanguage(e.target.value);
	};
	const renderActions = () => (
		<Box>
			<FormControl sx={{ m: 1, width: "fit-content" }} size="small">
				<InputLabel id="demo-select-small">{t("Language")}</InputLabel>
				<Select
					MenuProps={{
						disableScrollLock: true,
					}}
					labelId="demo-select-small"
					id="demo-select-small"
					defaultValue={"en"}
					label="Language"
					onChange={handleLanguageChange}
				>
					<MenuItem value={"en"}>English</MenuItem>
					<MenuItem value={"fr"}>French</MenuItem>
				</Select>
			</FormControl>

			<Typography
				component={Box}
				sx={{
					display: { xs: "none", md: "initial", fontWeight: "bold" },
				}}
				color="secondary"
			>
				{props.currentUser}
			</Typography>

			<Tooltip title={t("Open Settings")}>
				<IconButton onClick={handleOpenUserMenu}>
					<Avatar alt="Remy Sharp" src={`https://ui-avatars.com/api/?name=${props.currentUser}&length=1&background=0054a6&color=ffffff`} />
				</IconButton>
			</Tooltip>
			<Menu
				disableScrollLock={true}
				sx={{ mt: "45px" }}
				id="menu-appbar"
				anchorEl={anchorElUser}
				anchorOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				keepMounted
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				open={Boolean(anchorElUser)}
				onClose={handleCloseUserMenu}
			>
				{/* {settings.map((setting) => (
			<MenuItem key={setting} onClick={handleCloseUserMenu}>
				<Typography textAlign="center">{setting}</Typography>
			</MenuItem>
		))} */}
				{/* <MenuItem>
			<Link to="/applications" style={{ textDecoration: "none", color: "inherit" }}>
				<Typography style={{ color: "inherit" }}>Applications</Typography>
			</Link>
		</MenuItem> */}
				<MenuItem onClick={props.signOut}>
					<Typography textAlign="center">{t("Sign Out")}</Typography>
				</MenuItem>
			</Menu>
		</Box>
	);
	return (
		<AppBar position="static" style={{ marginBottom: "25px", backgroundColor: "#f5f7fb" }} elevation={0}>
			<Container maxWidth="xl">
				<Toolbar disableGutters style={{ height: "100px" }}>
					{/* DESKTOP NAVBAR */}
					<Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center", width: "100%", justifyContent: "space-between" }}>
						<Box display={"flex"} alignItems="center">
							<Box sx={{ mr: 1 }}>
								<img src={tamperproof_blue} style={{ maxHeight: "80px" }} />
							</Box>
							<Typography
								variant="h6"
								noWrap
								fontWeight={"bold"}
								color="black"
								sx={{
									mr: 2,
									display: { xs: "none", md: "flex" },
									fontWeight: 700,
									textDecoration: "none",
								}}
							>
								Police Certs
							</Typography>
						</Box>
						<Box sx={{ display: { xs: "none", md: "flex" } }}>
							<NavLink
								to="/dashboard"
								className={"navbar-link"}
								style={({ isActive, isPending }) => {
									return { textDecoration: isActive ? "underline" : "none", color: "inherit", marginRight: 16 };
								}}
							>
								<Typography color="primary" style={{ textDecoration: "inherit" }} fontWeight={"bold"}>
									{t("Active Application")}
								</Typography>
							</NavLink>
							<NavLink
								className={"navbar-link"}
								to="/record-history"
								style={({ isActive, isPending }) => {
									return { textDecoration: isActive ? "underline" : "none", color: "inherit", marginRight: 16 };
								}}
							>
								<Typography color="primary" style={{ textDecoration: "inherit" }} fontWeight={"bold"}>
									{t("Record History")}
								</Typography>
							</NavLink>
						</Box>
						{renderActions()}
					</Box>
					{/* MOBILE NAVBAR */}
					<Box sx={{ display: { xs: "flex", md: "none" }, justifyContent: "space-between", width: "100%", alignItems: "center" }}>
						<Box>
							<Box sx={{ display: { xs: "none", md: "flex" }, mr: 1 }}>
								<img src={tamperproof_blue} style={{ maxHeight: "80px" }} />
							</Box>
							<Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
								<IconButton
									size="large"
									aria-label="account of current user"
									aria-controls="menu-appbar"
									aria-haspopup="true"
									onClick={handleOpenNavMenu}
									color="primary"
								>
									<MenuIcon />
								</IconButton>
								<Menu
									id="menu-appbar"
									anchorEl={anchorElNav}
									anchorOrigin={{
										vertical: "bottom",
										horizontal: "left",
									}}
									keepMounted
									transformOrigin={{
										vertical: "top",
										horizontal: "left",
									}}
									open={Boolean(anchorElNav)}
									onClose={handleCloseNavMenu}
									sx={{
										display: { xs: "block", md: "none" },
									}}
								>
									<MenuItem onClick={handleCloseNavMenu}>
										<Link to="/dashboard" style={{ textDecoration: "none", color: "inherit", marginRight: 16 }}>
											<Typography color="primary" fontWeight={"bold"}>
												Active Application
											</Typography>
										</Link>
									</MenuItem>
									<MenuItem onClick={handleCloseNavMenu}>
										<Link to="/record-history" style={{ textDecoration: "none", color: "inherit", marginRight: 16 }}>
											<Typography color="primary" fontWeight={"bold"}>
												Record History
											</Typography>
										</Link>
									</MenuItem>
								</Menu>
								<Box sx={{ display: { xs: "flex", md: "none" }, mr: 1 }}>
									<img src={tamperproof_blue} style={{ maxHeight: "80px" }} />
								</Box>
							</Box>
						</Box>
						{renderActions()}
					</Box>
				</Toolbar>
			</Container>
		</AppBar>
	);
}
export default Navbar;
